import { render, staticRenderFns } from "./HelpDesks.vue?vue&type=template&id=6f789dfb&scoped=true&"
import script from "./HelpDesks.vue?vue&type=script&lang=js&"
export * from "./HelpDesks.vue?vue&type=script&lang=js&"
import style0 from "./HelpDesks.vue?vue&type=style&index=0&id=6f789dfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f789dfb",
  null
  
)

export default component.exports